import script from "./ParceriasCentralCoordenacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ParceriasCentralCoordenacao.vue?vue&type=script&setup=true&lang=js"

import "./ParceriasCentralCoordenacao.vue?vue&type=style&index=0&id=217f1e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217f1e2a"]])

export default __exports__